import styled from '@emotion/styled'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  children?: any
  delay?: Delay
}

export const DropDown = memo(function DropDown({
  children,
  delay = 0.6,
}: Props) {
  const [ref, isVisible] = useInView({
    triggerOnce: true,
  })

  return (
    <Container
      className={isVisible ? 'visible' : undefined}
      delay={delay}
      ref={ref}
    >
      {children}
    </Container>
  )
})

const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  clip-path: inset(0% 0% 100% 0%);
  overflow: hidden;
  position: relative;
  transition: 1.4s ${(props: Props) => props.delay}s ease-in-out;
  &.visible {
    clip-path: inset(0);
  }

  > div {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 767px) {
    transition-duration: 0.6s;
    transition-delay: 0s;
  }
`

interface ContainerProps {
  delay: Delay
}

export type Delay = number
